import * as React from 'react';
import { runwayColors } from './styles/globalStyles';
import Text from 'antd/lib/typography/Text';
import Link from 'antd/lib/typography/Link';
import { displaySubscriptionStatus } from '../helpers/displayHelpers';
import userflow from 'userflow.js';
import TrackedButton from '../helpers/TrackedButton';
import * as Amplitude from '../utils/analytics';
import { RootState } from '@/reducers/reducers';
import { selectOrg } from '@/selectors/selectors';
import { useSelector } from 'react-redux';
import { OrgComponentProps } from '@/typescriptHelpers';

export const USERFLOW_TRIAL_PROMPT_FLOW_ID = '24b6e157-9971-438d-9739-b572afd08d27';

export const presentUserflowTrialActivation = () => {
    userflow.start(USERFLOW_TRIAL_PROMPT_FLOW_ID);
};

interface TrialBannerProps extends OrgComponentProps {}

const TrialBanner: React.FC<TrialBannerProps> = (props: TrialBannerProps) => {
    const { isTrialStarted, trialType, trialDaysRemaining } = useSelector((state: RootState) => {
        const org = selectOrg(state, props.orgId)!;

        return {
            isTrialStarted: org.subscriptionInfo.isTrialStarted,
            trialType: org.subscriptionInfo.trialType,
            trialDaysRemaining: org.subscriptionInfo.trialDaysRemaining,
        };
    });

    // active trial
    if (isTrialStarted) {
        let daysText: string;
        let text1: string;
        let text2: string;

        if (trialDaysRemaining !== null) {
            text1 = 'You have ';
            daysText = trialDaysRemaining === 1 ? `${trialDaysRemaining} day` : `${trialDaysRemaining} days`;
            text2 = ' remaining in your ';
        } else {
            text1 = 'You are on a ';
            daysText = '';
            text2 = '';
        }

        return (
            <div
                style={{
                    backgroundColor: runwayColors.info,
                    padding: 8,
                    textAlign: 'center',
                }}
            >
                <Text style={{ fontSize: 13, color: 'white' }}>
                    {text1}
                    <strong>{daysText}</strong>
                    {text2}free trial of the Runway <strong>{displaySubscriptionStatus(trialType, false)}</strong> plan.{' '}
                    <Link
                        href={`#hs-chat-open`}
                        style={{ color: runwayColors.white, textDecoration: 'underline', textDecorationStyle: 'solid' }}
                    >
                        Get in touch
                    </Link>{' '}
                    to upgrade your organization&apos;s plan.
                </Text>
            </div>
        );
    }

    // pre trial
    return (
        <div
            style={{
                backgroundColor: runwayColors.info,
                padding: 8,
                textAlign: 'center',
            }}
        >
            <Text style={{ color: 'white' }}>
                🚀 Want to take Runway&apos;s full feature set for a test flight?{' '}
                <TrackedButton
                    orgId={props.orgId}
                    type="link"
                    style={{
                        margin: 0,
                        padding: 0,
                    }}
                    eventName={Amplitude.Event.ClickActivateOrgSubscriptionTrial}
                    extraProperties={{
                        placement: 'banner',
                    }}
                    onClick={presentUserflowTrialActivation}
                >
                    <Text
                        style={{
                            color: runwayColors.white,
                            textDecoration: 'underline',
                            textDecorationStyle: 'solid',
                            textDecorationColor: runwayColors.white,
                        }}
                    >
                        Click here to activate your<strong> free 3 week trial</strong>
                    </Text>
                </TrackedButton>
                .
            </Text>
        </div>
    );
};

export default TrialBanner;
